import {useQuery} from '@apollo/client';
import {useBuilderContext} from '../CreateBuilder/useBuilderContext';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import validateUUID from '../../../utils/validateUUID';
import {BUILDER_ANNUITY_POTS} from '../builderPotQueries';
import {reccNonEditable} from '../CreateBuilder/BuilderSourceDestination/CreateBuilderFooter';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {BuilderPot} from '../../../schema-types/BuilderPot';
import {
  BuilderAnnuityPots,
  BuilderAnnuityPotsVariables,
} from '../../../schema-types/BuilderAnnuityPots';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';

export const useAnnuityPotsQuery = (): {sourcePots: BuilderPot[]} => {
  const {builderDetails, builderReviewId} = useBuilderContext();
  const {values} = useAutoForm<builderFieldsType>();
  const contactId = values.contact ? validateUUID(values.contact) : null;
  const reviewId = validateUUID(builderReviewId);
  const isNonEditable = !!reccNonEditable(builderDetails);
  const editable = !isNonEditable;

  const enableFetch =
    editable &&
    values.planAction === OVRecommendActionEnum.SET_UP_NEW &&
    values.mainPlanType === 'annuity' &&
    reviewId &&
    contactId;

  const {data} = useQuery<BuilderAnnuityPots, BuilderAnnuityPotsVariables>(
    BUILDER_ANNUITY_POTS,
    {
      variables: {
        reviewId: reviewId!,
        contactId: contactId!,
      },
      skip: !enableFetch,
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );

  if (isNonEditable) {
    const savedPot = builderDetails?.annuity?.pot;
    return {sourcePots: savedPot ? [savedPot] : []};
  }
  return {sourcePots: data?.annuityPots?.sources ?? []};
};
